import React from 'react'
import { MaskedInputField } from '@adc/ui-core'
const ccNumberMask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const CardNumber = props => {
  return (
    <MaskedInputField
      autoComplete='cc-number'
      guide={false}
      label='Credit Card'
      mask={ccNumberMask}
      {...props}
    />
  )
}

export default CardNumber
